// extracted by mini-css-extract-plugin
module.exports = {"action":"Login_action__1mYBT","monthsdata":"Login_monthsdata__2dB-x","label":"Login_label__2bVGv","forgotPassword":"Login_forgotPassword__1dA6S"};